import { Component, Input } from "@angular/core";
import { TabsContainer } from "../../containers";
var TabComponent = /** @class */ (function () {
    function TabComponent(tabs) {
        tabs.addTab(this);
    }
    TabComponent.prototype.getTabTitle = function () {
        return this.tabTitle;
    };
    TabComponent.decorators = [
        { type: Component, args: [{
                    selector: "tab",
                    host: {
                        "[class.hidden]": "!active"
                    },
                    template: "\n    <div class=\"tabs__panel\">\n      <ng-content></ng-content>\n    </div>\n  ",
                    styles: ["\n    *{margin:0px;padding:0px}:host{display:flex;height:100%}:host(.hidden){display:none}.tabs__panel{background-color:#fff;width:100%;padding:30px 15px}\n  "]
                },] },
    ];
    /** @nocollapse */
    TabComponent.ctorParameters = function () { return [
        { type: TabsContainer, },
    ]; };
    TabComponent.propDecorators = {
        'active': [{ type: Input },],
        'tabTitle': [{ type: Input },],
    };
    return TabComponent;
}());
export { TabComponent };
//# sourceMappingURL=tab.component.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-tabs-component/dist/components/tabs/tab.component.js
// module id = ./node_modules/angular-tabs-component/dist/components/tabs/tab.component.js
// module chunks = vendor